module.exports = __webpack_public_path__ + "img/hero-rounded-bottom.b3d33f62.svg";